module.exports = __webpack_public_path__ + "static/media/icn-chevron-rigth-24px.6102f04a.svg";